import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const apiClient = axios.create({ baseURL: API });

export function getAdminToken() {
  return localStorage.getItem("aq_admin_token");
}

export function setAdminToken(t) {
  if (t) localStorage.setItem("aq_admin_token", t);
  else localStorage.removeItem("aq_admin_token");
}

export const adminAxios = () => {
  const token = getAdminToken();
  return axios.create({
    baseURL: API,
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
};
